import { keyframes, styled } from "@mui/material";

/** Estilos de componentes comunes: Logo, ScrollTop y encabezado de sección. */
export const StyledLogo = {
  Wrapper: styled("span", {
    shouldForwardProp: (prop) => prop !== "light",
  })(({ theme, light }) => ({
    display: "inline-flex",
    alignItems: "center",
    "& img": {
      height: light ? 46 : 42,
      width: "auto",
      // Anula el reset global `img { max-width: 100% }`, que dentro del
      // header flex (shrink-to-fit) comprime el ancho del logo y lo deforma.
      maxWidth: "none",
      display: "block",
      // En el footer (fondo oscuro) el logo azul se pinta de blanco
      filter: light ? "brightness(0) invert(1)" : "none",
    },
  })),
};

export const StyledScrollTop = {
  Button: styled("button", {
    shouldForwardProp: (prop) => prop !== "visible",
  })(({ theme, visible }) => ({
    position: "fixed",
    right: 24,
    bottom: 24,
    zIndex: 90,
    width: 48,
    height: 48,
    display: "grid",
    placeItems: "center",
    border: "none",
    fontSize: "1.3rem",
    color: "#fff",
    background: theme.custom.gradient.brand,
    borderRadius: "50%",
    cursor: "pointer",
    boxShadow: "0 14px 30px -12px rgba(23, 79, 155, 0.8)",
    opacity: visible ? 1 : 0,
    transform: visible ? "translateY(0) scale(1)" : "translateY(20px) scale(0.8)",
    pointerEvents: visible ? "auto" : "none",
    transition: "opacity 0.3s ease, transform 0.3s ease",
    "&:hover": { transform: "translateY(-3px) scale(1.05)" },
  })),
};

export const StyledSectionHeading = {
  Root: styled("div", {
    shouldForwardProp: (prop) => prop !== "center",
  })(({ theme, center }) => ({
    maxWidth: 760,
    textAlign: center ? "center" : "left",
    marginInline: center ? "auto" : 0,
  })),
};
